class HeaderJs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttonMenuMobile = this.querySelector('.header__mobile-button');
    if (this.buttonMenuMobile) {
      this.buttonMenuMobile.addEventListener('click', () => {
        this.toggleClass();
      });
    }

    this.megaMenuItems = this.querySelectorAll('.menu-item.has-mega');

    this.megaMenuItems.forEach((item) => {
      const button = item.querySelector(':scope > .menu-link');
      const menu = item.querySelector(':scope > .mega-menu');

      if (!button || !menu) return;

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleMegaMenu(menu);
      });

      menu.addEventListener('mouseleave', () => {
        this.closeMegaMenu(menu);
      });
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.closeMegaMenus();
      }
    });

    this.cartBadge = this.querySelector('.header__cart-badge');
    this.updateCartCount(); 

    document.addEventListener('cart:updated', (e) => {
      const cart = e?.detail;
      if (cart && typeof cart.item_count !== 'undefined') {
        this.setCartCount(cart.item_count);
      } else {
        this.updateCartCount();
      }
    });
  }

  setCartCount(count) {
    if (!this.cartBadge) return;
    const n = Number(count) || 0;
    this.cartBadge.textContent = n;
  }


  async updateCartCount() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Erreur fetch /cart.js');
      const cart = await res.json();
      this.setCartCount(cart.item_count);
    } catch (err) {
      console.error('Impossible de récupérer le panier :', err);
    }
  }

  toggleClass() {
    this.menuMobile = this.querySelector('.header__menu-mobile__container');
    this.crossIcon = this.querySelector('.icon-cross');
    this.burgerIcon = this.querySelector('.icon-burger');

    this.menuMobile.classList.toggle('open');

    if (this.menuMobile.classList.contains('open')) {
      this.crossIcon.style.display = 'flex';
      this.burgerIcon.style.display = 'none';
    } else {
      this.crossIcon.style.display = 'none';
      this.burgerIcon.style.display = 'flex';
    }
  }

  toggleMegaMenu(menu) {
    if (!menu) return;
    const isOpen = menu.classList.contains('open');
    this.closeMegaMenus();
    menu.classList.toggle('open', !isOpen);
  }

  closeMegaMenu(menu) {
    if (!menu) return;
    menu.classList.remove('open');
  }

  closeMegaMenus() {
    this.querySelectorAll('.mega-menu.open').forEach((menu) => {
      this.closeMegaMenu(menu);
    });
  }
}

customElements.define('header-js', HeaderJs);
